import get from 'transmute/get';
export const getId = get('id');
export const getVersion = get('version');
export const getTimestamp = get('timestamp');
export const getData = get('data');